import {cardTitle, tooltip} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import modelosStyle from "./modelosStyle";

const formacoesStyle = {
  ...customCheckboxRadioSwitch,
  cardTitle,
  tooltip,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: "#999999 !important",
    textAlign: "center"
  },
  description: {
    color: "#999999"
  },
  updateProfileButton: {
    float: "right"
  },
  cursosContainer: {
    "&> div > div > h2": {
      padding: "0",
      margin: "0"
    }
  },
  tableActions: {
    float: "right",
    marginTop: "-50px"
  },
  searchInput: {
    paddingTop: 0,
    marginTop: 0
  },
  addCourseButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  buttonConfirm: {
    width: "150px"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectMenu: {
    zIndex: 9000
  },
  datetime: {
    margin: "15px 0"
  },
  percursoForm: {
    padding: "0 10px"
  },
  percursoAccordion: {
    backgroundColor: "#f8f8f8",
    padding: "0 10px",
    borderRadius: "6px!important",
    marginBottom: "5px",
    "&>div": {
      paddingTop: "10px!important"
    },
    "& label": {
      color: "#616161!important"
    }
  },
  percursoUserSearchForm: {
    marginBottom: "5px",
    "& label": {
      top: "20px"
    }
  },
  selectFormControl: {
    ...customSelectStyle.selectFormControl,
    margin: "10px 1px 10px 0px !important"
  },
  userCaixa: {
    "&:hover": {
      backgroundColor: "#007c39",
      textDecoration: "underline"
    },
    padding: "4px 10px",
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: "#30af48",
    color: "white",
    display: "inline-block !important",
    marginBottom: "10px"
  },
  userDetails: {
    fontSize: "11px",
    color: "#494949"
  },
  userLabel: {
    display: "block",
    marginBottom: "5px"
  },
  editObservacoesButton: {
    width: "30px",
    maxWidth: "30px",
    margin: 0,
    padding: 0,
    height: 30,
    minWidth: 0,
    float: "right",
    color: "#f78200",
    "&:hover, &:focus": {
      color: "#ef7c00"
    }
  },
  percursoButtons: {
    marginTop: 15,
    textAlign: "center",
    "& > *": {
      marginLeft: "5px",
      marginRight: "5px"
    }
  },
  addStuffButton: {
    padding: "5px 12px 5px 10px!important",
    marginLeft: "10px!important"
  },
  cursosUltimaColuna: {
    width: 100
  },
  modalCardTitle: {
    fontSize: "20px",
    position: "relative",
    top: "5px",
    left: "10px"
  },
  addForm: {
    padding: "0 10px"
  },
  itemDetalhes: {
    textAlign: "center",
    margin: "18px 0",
    "& h4": {
      margin: 0
    },
    "& p": {
      margin: 0,
      marginTop: 5,
      fontSize: 13,
      textTransform: "uppercase"
    }
  },
  outrosDetalhes: {
    marginTop: 20,
    "& h4": {
      borderBottom: "solid #35ab50 2px",
      display: "inline-block",
      minWidth: "60%"
    }
  },
  percursoDetails: {
    "& table": {
      width: "100%",
      "& td:first-child": {
        fontWeight: "bold"
      }
    }
  },
  tipoCursoHeaderContainer: {
    padding: "15px 20px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  tipoCursoHeaderTypeLabel: {
    backgroundColor: "#399b5f",
    padding: "4px 10px",
    color: "white",
    borderRadius: "6px",
    textTransform: "uppercase",
    fontSize: "12px",
    marginLeft: "10px"
  },
  tipoCursoAccordionWrapper: {
    padding: 20,
    backgroundColor: "#edf8fb",
    boxShadow: "inset 0px 35px 10px -30px rgba(0,0,0,0.05), inset 0px -35px 10px -30px rgba(0,0,0,0.05)"
  },
  cursoCardContainer: {
    position: "relative",
    backgroundColor: "#ffffff",
    borderRadius: "4px",
    padding: "10px 15px",
    boxShadow: "2px 3px 7px 1px #00000008",
    border: "solid 1px #eaeaea",
    marginBottom: "10px"
  },
  cursoCardTitle: {
    fontSize: 14,
    textAlign: "center",
    margin: 0
  },
  cursoCardPrice: {
    fontSize: "12px",
    fontWeight: "400",
    borderRadius: "4px",
    backgroundColor: "#f1f1f1",
    padding: "1px 5px",
    width: "fit-content"
  },
  eventLabel: {
    textAlign: "center",
    "& h2": {
      margin: 0
    },
    "& p": {
      textTransform: "uppercase",
      margin: 0,
      fontWeight: 500,
      fontSize: 21,
    }
  },
  buttonAnterior: {
    padding: "5px 12px 5px 10px!important",
    marginRight: "auto",
  },
  buttonSeguinte: {
    padding: "5px 12px 5px 10px!important",
  },
  addModuloButton: modelosStyle.addModuloButton,
};

export default formacoesStyle;
